import React, { useReducer, createContext } from 'react'
import { jwtDecode } from 'jwt-decode'

const initialState = {
    user: null
}

if (localStorage.getItem('token')) {
    // we use the token in storage and allow the server
    // to determine if it can replace any expired access tokens or reject access
    initialState.user = jwtDecode(localStorage.getItem('token'))
}

const AuthContext = createContext({
    user: null,
    login: (userData) => {},
    logout: () => {}
})

const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                user: jwtDecode(action.payload.token)
            }
        case 'LOGOUT':
            return {
                ...state,
                user: null
            }
        default:
            return state
    }
}

const AuthProvider = (props) => {
    const [state, dispatch] = useReducer(authReducer, initialState)

    const login = (userData) => {
        localStorage.setItem('token', userData.token)
        dispatch({
            type: 'LOGIN',
            payload: userData
        })
    }

    const logout = () => {
        localStorage.removeItem('token')
        dispatch({ type: 'LOGOUT' })
    }

    return (
        <AuthContext.Provider
            value={{ user: state.user, login, logout }}
            { ...props }
        />
    )
}

export { AuthContext, AuthProvider }